require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./code-fellows-partners.json") })
        }
      }, "path---code-fellows-partners");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---code-fellows-partners!./.cache/json/code-fellows-partners.json
// module id = 1157
// module chunks = 231608221292675